import { useHistory } from "react-router-dom"
import { ReactComponent as ChargedIcon } from "@/Images/icons/Charged.svg"
import { Button } from "@/components/Button"
import { FormattedMessage } from "react-intl"

export const Charged = ({ title }: { title?: string }) => {
  const history = useHistory()
  return (
    <div className="charged">
      <ChargedIcon />
      <h1>{title ?? <FormattedMessage id="charged" />}</h1>
      <p>
        <FormattedMessage id="exchange-done" />
      </p>
      <Button className="mt-[20px]" variant="outlined" onClick={() => history.push("/")}>
        <FormattedMessage id="go-to-area" />
      </Button>
    </div>
  )
}
